/**
 * @fileoverview Saved search searcher for user-favorited searches.
 * @module searchers/SavedSearcher
 */

import { IntSearcher } from './IntSearcher.js';
import { createIntSearcherConfig } from './IntSearcherConfigs.js';
import { SEARCH_TYPES, DOM_ELEMENTS } from '../constants.js';


/**
 * Manages explicitly saved/favorited searches.
 * Unlike HistorySearcher which auto-records searches, this stores
 * only searches the user explicitly chooses to save. Provides
 * quick access to frequently used searches.
 * @class
 * @extends IntSearcher
 */
export class SavedSearcher extends IntSearcher {
    /**
     * Creates a new SavedSearcher instance.
     * @param {Object} mapApp - The MapApp instance
     * @param {Object} [options={}] - Configuration options
     */
    constructor(mapApp, options = {}) {
        const config = createIntSearcherConfig(SEARCH_TYPES.SAVEDSEARCH, options);

        super(mapApp, config);
    }




    // Click handling is inherited from Searcher.handleItemClick()
    // which handles delete button, execute button, and doubleclick on searches




    // ==========================================
    // SavedSearch HELPER METHODS
    // ==========================================
    // These methods provide saved-search-specific naming while delegating to
    // the generic CRUD methods in IntSearcher.



    /**
     * Checks if a search is saved.
     * @param {string} uid - The unique identifier of the search to check
     * @returns {boolean} True if the search is saved
     */
    isSavedSearchByUid(uid) {
        return this.hasItemByUid(uid);
    }

    /**
     * Toggles the saved state for the given uid.
     * @param {string} uid - The unique identifier of the search to toggle
     * @param {Object} item - The search item (used when adding)
     * @returns {boolean} True if the search is now saved, false if removed
     */
    addOrRemoveSavedSearchByUidItem(uid, item) {
        const debugMessage = 'addRemove saved search';
        return this.addOrRemoveItemByUidItem(uid, item, debugMessage);
    }
}
